export var EOpenMode;
(function (EOpenMode) {
    EOpenMode["EXPANDED"] = "EXPANDED";
    EOpenMode["MINIMIZED"] = "MINIMIZED";
    EOpenMode["COLLAPSED"] = "COLLAPSED";
})(EOpenMode || (EOpenMode = {}));
